import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'rebass/styled-components';
import { Row, Button } from '../components';

function Rules(props) {
  const { setSelectedRule, selectedRule } = props;

  const [rules, setRules] = useState([]);

  const hasSelectedRule = selectedRule && Object.keys(selectedRule).length > 0;

  const handleRuleClick = (rule) => {
    if (setSelectedRule) {
      if (hasSelectedRule && rule && rule.id === selectedRule.id) {
        setSelectedRule({});
      }

      if (rule && selectedRule && rule.id !== selectedRule.id && rule.enabled) {
        setSelectedRule(rule);
      } else {
        setSelectedRule({});
      }
    }
  };

  const handleToggleChange = (rule, value) => {
    setRules(
      rules.map((r) => {
        if (r.id === rule.id) {
          return { ...r, enabled: value };
        }
        return r;
      }),
    );
  };

  return (
    <Box flex={1} mb={3} mr={3}>
      <Flex mb={3}>
        <Button variant="primary" mr={2}>
          New
        </Button>
      </Flex>
      {rules.map((rule) => (
        <Row
          key={rule.id}
          data={rule}
          handleClick={handleRuleClick}
          handleChange={handleToggleChange}
          isActive={hasSelectedRule && selectedRule.id === rule.id}
        />
      ))}
    </Box>
  );
}

Rules.defaultProps = {
  setSelectedRule: undefined,
  selectedRule: undefined,
};

Rules.propTypes = {
  setSelectedRule: PropTypes.func,
  selectedRule: PropTypes.object,
};

export default Rules;
